import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Card, CardContent } from '../components/ui/card';
import { Truck, ShieldCheck } from 'lucide-react';

const PublicDisposalTicketPage = () => {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/public/disposal-tickets/${token}`;
    axios.get(url).then(r => setData(r.data)).catch(e => setError(e.response?.data?.detail || 'Ticket not found'));
  }, [token]);

  if (error) return <div className="min-h-screen flex items-center justify-center bg-slate-100"><div className="text-center"><p className="text-red-600 font-semibold">{error}</p></div></div>;
  if (!data) return <div className="min-h-screen flex items-center justify-center bg-slate-100"><div className="spinner" /></div>;

  return (
    <div className="min-h-screen bg-slate-50 py-12 px-4" data-testid="public-disposal-page">
      <div className="max-w-xl mx-auto">
        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-orange-100 mb-3"><Truck className="w-8 h-8 text-orange-600" /></div>
          <h1 className="text-2xl font-bold text-slate-900">{data.ticket_number}</h1>
          <p className="text-slate-500 text-sm">Disposal Ticket — public scan view</p>
        </div>
        <Card className="industrial-card">
          <CardContent className="p-6 space-y-3">
            <div className="flex items-center justify-between border-b border-slate-100 pb-3">
              <span className="text-xs uppercase tracking-wider text-slate-500">Status</span>
              <span className="font-mono text-sm font-semibold">{data.status}</span>
            </div>
            <div><span className="text-xs uppercase text-slate-500 block mb-0.5">Kind</span><span className="text-sm">{data.ticket_kind?.replace('_', ' ')}</span></div>
            {data.serial_number && <div><span className="text-xs uppercase text-slate-500 block mb-0.5">Serial #</span><span className="text-sm mono">{data.serial_number}</span></div>}
            {data.item_sku && <div><span className="text-xs uppercase text-slate-500 block mb-0.5">Item</span><span className="text-sm mono">{data.item_sku}</span> {data.item_name && <span className="text-xs text-slate-500">· {data.item_name}</span>}</div>}
            {data.quantity != null && <div><span className="text-xs uppercase text-slate-500 block mb-0.5">Quantity</span><span className="text-sm mono">{data.quantity} {data.base_uom || ''}</span></div>}
            {data.batch_lot && <div><span className="text-xs uppercase text-slate-500 block mb-0.5">Batch / Lot</span><span className="text-sm mono">{data.batch_lot}</span></div>}
            <div><span className="text-xs uppercase text-slate-500 block mb-0.5">Reason</span><span className="text-sm">{data.reason}</span></div>
            <div><span className="text-xs uppercase text-slate-500 block mb-0.5">Method</span><span className="text-sm">{data.disposal_method || '—'}</span></div>
            {data.disposed_at && (
              <div className="bg-emerald-50 border border-emerald-200 rounded-sm p-3 flex items-center gap-2 mt-3">
                <ShieldCheck className="w-5 h-5 text-emerald-600" />
                <div className="text-sm">
                  <div className="font-semibold text-emerald-800">Disposed</div>
                  <div className="text-emerald-700 text-xs">{data.disposed_by_name} · {new Date(data.disposed_at).toLocaleString()}</div>
                </div>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PublicDisposalTicketPage;
